import React, { Component } from "react"
import { connect } from "react-redux"
import { isEmpty } from "lodash"
import { withRouter } from "react-router-dom"
import { css } from "@emotion/core"
import AdminGalleryForm from "./AdminGalleryForm"
import AdminMainLayout from './AdminMainLayout'
import { adminGalleriesList } from "../actions/admin_galleries"

class AdminGallery extends Component {
  componentDidMount() {
      const { dispatch, gallery_id } = this.props
    dispatch(adminGalleriesList.invalidateList())
      dispatch(adminGalleriesList.ensureObjectLoaded(gallery_id))

  }

  onSave = (values) => {
    const { dispatch, history, gallery_id } = this.props
      const on_done = function () {
          dispatch(adminGalleriesList.invalidateList())
          dispatch(adminGalleriesList.fetchListIfNeeded())
          history.push("/admin/galleries")
        }
        if (gallery_id) {
          values.id = gallery_id
          return dispatch(adminGalleriesList.saveObject(values)).then(on_done)
        } else {
          return dispatch(adminGalleriesList.saveNewObject(values)).then(on_done)
        }
  }

  render() {
      const {gallery, initial_values, } = this.props
      return (
          <AdminMainLayout>
            <h2>
              {`${isEmpty(initial_values) ? "Add new" : "Edit"}`} gallery
            </h2>
            <AdminGalleryForm
              onSave={ this.onSave }
              gallery={ gallery }
              initial_values={ initial_values }
            />
          </AdminMainLayout>
      )
  }
}
function mapStateToProps(state, props) {
  const { gallery_id } = props.match.params
  const gallery = adminGalleriesList.getObject(gallery_id)
  const initial_values = gallery
  return {
    gallery_id,
    gallery,
    initial_values,
    is_busy: adminGalleriesList.isLoading()
  }
}
export default withRouter(connect(mapStateToProps)(AdminGallery))

const image = css`
  width: 80%;
`
